import { AZURE_ACTIVE_DOMAIN } from "../config/globalVariables";
import { PublicClientApplication } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: AZURE_ACTIVE_DOMAIN.appId,
    authority:
      "https://login.microsoftonline.com/" + AZURE_ACTIVE_DOMAIN.tenant,
    redirectUri: AZURE_ACTIVE_DOMAIN.redirectUri,
  },
  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export async function getAccessToken() {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    const result = await msalInstance.acquireTokenSilent({
      scopes: ["Calendars.ReadWrite"],
      account: accounts[0],
    });
    return result.accessToken;
  } else {
    const result = await msalInstance.loginPopup({
      scopes: ["Calendars.ReadWrite"],
    });
    return result.accessToken;
  }
}

export const apiConfig = {
  resourceScopes: AZURE_ACTIVE_DOMAIN.scopes,
};

export const loginRequest = {
  scopes: ["openid", "profile", "offline_access", ...apiConfig.resourceScopes],
  prompt: "select_account",
};

export const silentRequest = {
  scopes: [...apiConfig.resourceScopes],
};
export const tokenRequest = {
  scopes: [...apiConfig.resourceScopes],
};
